import React from "react";
import "./Footer.css";

const Footer = (props) => {
  return (
    <div className="Footer">
      <footer className="main-footer">
        <div className="pull-right hidden-xs">
          <b>Version</b> 1.0.0
        </div>
        <strong>
          Copyright &copy; 2025{" "}
          <a
            href="https://www.foodzaps.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            FoodZaps
          </a>
          .
        </strong>{" "}
        All rights reserved.
      </footer>
    </div>
  );
};

export default Footer;
